import { ampReportSecClassMap } from './secClassMap';

export function convertSecClass(secClass: number): string {
  return ampReportSecClassMap[secClass];
}
